module.exports = __webpack_public_path__ + "img/sld.d9207872.svg";